/* eslint-disable */
export default {
  add: '新增',
  noCalls: '沒有可用通話',
  activeCall: '進行中的通話',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
